import { useCallback } from "react";
import useSWRInfinite  from "swr/infinite";

import { getStreamsToBeDeleted } from "_services/api/creator-plus";

import Presentation from "./presentation";

const swrKey = "streams-to-be-deleted";

const fetcher = async params => {
	const { pageNo, pageSize } = params;

	const res = await getStreamsToBeDeleted ( { pageNo, pageSize } );

	// Return both streams, totalNoOfStreams, and deletionTime for first page
	return {
		streams          : res?.streams || [],
		totalNoOfStreams : res?.totalNoOfStreams || 0,
		deletionTime     : res?.deletionTime || null
	};
};

const CreatorPlusProfileNew = props => {
	const {
		profile,
		// ugcStats, // check if we really need this
		userId,
		activeTab,
		activeTabData,
		deletionTime,
		streamsToDelete,
		totalNoOfStreams,
		updateDeletedPost
	} = props;

	// Use streams from parent as initial data if available
	const initialData = streamsToDelete && streamsToDelete.length > 0
		? [ {
			streams          : streamsToDelete,
			totalNoOfStreams : totalNoOfStreams || streamsToDelete.length,
			deletionTime     : deletionTime || null
		} ]
		: undefined;

	const { data, error, size, setSize, mutate } = useSWRInfinite (
		index => {
			return {
				key      : swrKey,
				pageNo   : index + 1,
				pageSize : 20
			};
		},
		fetcher,
		{
			revalidateFirstPage   : false,
			revalidateOnMount     : false,
			revalidateOnFocus     : false,
			revalidateOnReconnect : false,
			revalidateIfStale     : false,
			fallbackData          : initialData
		}
	);

	// Handle stream deletion by updating the cache
	const handleDeleteStream = useCallback ( deletedStreamId => {
		if ( !data )
			return;

		// Filter out the deleted stream from all pages
		const updatedData = data.map ( page => {
			const filteredStreams = page.streams.filter ( stream => stream.id !== deletedStreamId );

			return {
				...page,
				streams          : filteredStreams,
				totalNoOfStreams : page.totalNoOfStreams - 1
			};
		} );

		// Update the cache immediately
		mutate ( updatedData, false );

		// Call parent's updateDeletedPost if provided
		if ( updateDeletedPost ) {
			updateDeletedPost ( deletedStreamId );
		}
	}, [ data, mutate, updateDeletedPost ] );

	const isLoadingInitialData = !data && !error;

	// Check if we've loaded all available streams
	const allStreams     = [].concat.apply ( [], ( data || [] ).map ( page => page?.streams || [] ) );
	const totalAvailable = data?.[0]?.totalNoOfStreams || totalNoOfStreams || 0;
	const isDepleted     = totalAvailable > 0 && allStreams.length >= totalAvailable;
	const isLoadingMore  = isLoadingInitialData || ( size > 0 && data && typeof data[size - 1] === "undefined" );

	// Flatten the paginated data - extract streams from each page
	const streams = [].concat.apply ( [], ( data || [] ).map ( page => page?.streams || [] ) );

	// Get total count and deletionTime from first page response or props
	const totalCount = data?.[0]?.totalNoOfStreams || totalNoOfStreams || streams.length;

	const deletionTimeFromAPI = data?.[0]?.deletionTime || deletionTime || null;

	const fetchMore = () => {
		if ( !isDepleted && !isLoadingMore ) {
			setSize ( size + 1 );
		}
	};

	return (
		<Presentation
			deletionTime     = { deletionTimeFromAPI }
			fetchMore        = { fetchMore }
			isDepleted       = { isDepleted }
			isLoading        = { isLoadingInitialData }
			isLoadingMore    = { isLoadingMore }
			onClose          = { props.onClose }
			onDeleteStream   = { handleDeleteStream }
			streams          = { streams }
			totalCount       = { totalCount }
		/>
	);
};

export default CreatorPlusProfileNew;

